export const types = {
  causes: "[GET] Causes",
  addCauses: "[POST] Causes",
  removeCauses: "[DELETE] Causes",
  addCoins: "[POST] CausesPoints",
  refreshCauses: "[POST] Causes",
};
